export default {
  items: {
    ru: {
      title: 'Русский',
      value: 'ru',
    },
    en: {
      title: 'English',
      value: 'en'
    }
  },
};
